function goToLinkScroll() {
  /**
   * ページ内リンクスクロール
   * @param number currentTime 経過時間
   * @param number startValue  初期値
   * @param number changeValue 初期値からの変化量
   * @param number duration    処理時間
   * @returns number 変化量
   */
  const easingEaseOutExpo = function (currentTime, startValue, changeValue, duration) {
    return changeValue * (-1 * Math.pow(2, -10 * currentTime / duration) + 1) + startValue;
  };

  const linkScrolls = document.getElementsByClassName('link-scroll');
  let start = null;

  for (let i = 0, l = linkScrolls.length; i < l; i++) {
    linkScrolls[i].addEventListener('click', () => {
      if (linkScrolls[i].dataset.target) {
        const baseY = document.documentElement.scrollTop || document.body.scrollTop;
        const targetObj = document.getElementById(linkScrolls[i].dataset.target).getBoundingClientRect();
        function step(timestamp) {
          if (!start) start = timestamp;
          const progress = timestamp - start;

          // progress(timestamp, start)はミリ秒
          window.scrollTo(0, easingEaseOutExpo(progress / 1000, baseY, (targetObj.top + baseY) - baseY - 50 , 1));
          if (progress < 1 * 1000) {
            window.requestAnimationFrame(step);
          } else {
            start = null;
          }
        }

        window.requestAnimationFrame(step);
      }
    }, false);
  }
}

goToLinkScroll();
